<div class="checkbox-content">
  <input
    #inputEl
    type="checkbox"
    [checked]="!!value"
    [disabled]="!!disabled"
    [readonly]="!!readOnly"
    (change)="onCheckedChange()"
  />

  <div class="checkmark">
    <app-iconic class="icon" icon="assets/icons/check.svg"></app-iconic>
  </div>
</div>

<div class="label" *ngIf="!!(label || checkboxLabelTpl)" (click)="onLabelClick()">
  <ng-container [ngSwitch]="!!(checkboxLabelTpl) ? 1 : 2">
    <ng-template *ngSwitchCase="1" [ngTemplateOutlet]="checkboxLabelTpl?.templateRef" [ngTemplateOutletContext]="{label}">
    </ng-template>

    <ng-container *ngSwitchDefault>
      {{ label }}
    </ng-container>
  </ng-container>

</div>
